import React from 'react';
import {
  MenuItem, ListItemIcon,
} from '@mui/material';
import { makeStyles, withStyles } from '@mui/styles';
import { RouteComponentProps } from 'react-router-dom';
import Logout from '@mui/icons-material/Logout'
import { resetEncryptedToken, resetLoggedInUser } from '../../redux/common-data-slice';
import stylesheet from '../patients/detail/detail-container.stylesheet'
import { useAppThunkDispatch } from '../../redux/store';
import { useOktaAuth } from '@okta/okta-react';

interface IProps extends RouteComponentProps {
  history: any;
  location: any;
  match: any;
  handleLogout: any
}

const styles = makeStyles(() => ({
  menuItem: {
    padding: '0.2rem 0.4rem !important',
    fontSize: '0.7rem !important',
    '&.MuiMenuItem-root, & .MuiListItemIcon-root': {
      paddingLeft: '0.3rem !important',
    },
    '&:hover': {
      color: '#F06423 !important',
      '& .MuiListItemIcon-root': {
        color: '#F06423 !important',
      }
    },
  },
}));

const OktaLogoutComponent: React.FC<IProps> = ({ handleLogout }) => {
  const { oktaAuth } = useOktaAuth()  // Use the shared instance owned by <Security>
  const dispatch = useAppThunkDispatch()
  const classes = styles()

  const logout = async () => {
    // Block authStateManager from firing signInWithRedirect() during teardown
    sessionStorage.setItem('oktaLoggingOut', 'true')

    handleLogout()
    dispatch(resetLoggedInUser())
    dispatch(resetEncryptedToken())

    // IMPORTANT: do NOT clear localStorage here.
    // signOut() reads the ID token from storage to include as id_token_hint in the
    // Okta logout URL. Without it, Okta may not close the server session and the
    // user gets auto-signed back in via SSO instead of seeing the login form.
    //
    // All storage is cleared in beforeunload — after signOut() has built the URL
    // but just before the browser actually navigates away.
    window.addEventListener('beforeunload', () => {
      localStorage.clear()
      sessionStorage.clear()
      // oktaLoggingOut is gone (sessionStorage.clear) so signInWithRedirect()
      // fires naturally when the app reloads at postLogoutRedirectUri (origin).
    }, { once: true })

    try {
      await oktaAuth.signOut({ postLogoutRedirectUri: window.location.origin })
    } catch (_) {
      localStorage.clear()
      sessionStorage.clear()
      oktaAuth.signInWithRedirect({ redirectUri: window.location.origin + '/login/callback' })
    }
  }

  return (<MenuItem onClick={logout} className={classes.menuItem}>
    <ListItemIcon><Logout fontSize="small" /></ListItemIcon>Logout
  </MenuItem>
  );
};

export default withStyles(stylesheet)(OktaLogoutComponent);
